"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("./DataObjectConverter");
/**
 * Adds methods to convert only subset of object. Subject of the conversion must be domain object and provide
 * `getEmpty()` implementation.
 *
 * @author Jan Prokop
 */


var PartialDataObjectConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PartialDataObjectConverter, _DataObjectConverter_);

  function PartialDataObjectConverter() {
    _classCallCheck(this, PartialDataObjectConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PartialDataObjectConverter).apply(this, arguments));
  }

  _createClass(PartialDataObjectConverter, [{
    key: "toPartialObject",

    /**
     * Converts possibly partial external representation to a domain model object with specified constructor.
     * Be aware by default constructor won't be called, only prototype will be assigned. That also means default values
     * won't be assigned. If constructor should be called, you have to implement static `fromDataDict` method of domain class.
     *
     * @param source
     * @param conversions
     * @param constructor
     */
    value: function toPartialObject(source, conversions, constructor) {
      // create base object for conversion
      var baseDocument = this.toDocument(this.getEmpty(), conversions); // assign values from partial source to empty base document

      var sourceKeys = Object.keys(source);
      sourceKeys.forEach(function (key) {
        baseDocument[key] = source[key];
      }); // convert base document to full object

      var baseObject = this.toObject(baseDocument, conversions); // create object of converted values with the keys from the source, ignore fields not in base object

      var obj = {};
      sourceKeys.forEach(function (key) {
        if (baseObject[key] !== undefined) {
          obj[key] = baseObject[key];
        }
      }); // create and return partial domain object

      if (constructor.fromDataDict) {
        return constructor.fromDataDict(obj);
      } else {
        Object.setPrototypeOf(obj, constructor.prototype);
        return obj;
      }
    }
    /**
     * Converts possibly partial domain object to external representation with the same members.
     *
     * @param source
     * @param conversions
     */

  }, {
    key: "toPartialDocument",
    value: function toPartialDocument(source, conversions) {
      var baseDocument = this.toDocument(this.getEmpty().copyMulti(source), conversions);
      var doc = {};
      Object.keys(source).forEach(function (key) {
        doc[key] = baseDocument[key];
      });
      return doc;
    }
  }]);

  return PartialDataObjectConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PartialDataObjectConverter = PartialDataObjectConverter;